import { Dialog, DialogTitle, Grid, IconButton, DialogContent,Button,Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import * as React from 'react'
import useStyles from '../../assets/styles'

export const DialogPopup = (props) =>{
    const classes = useStyles();
    const dialogContentClasses = props.isFeedBack ? (props.needsAdditionalPadding ? classes.feedbackAdditionalContent : classes.feedBackContent) : classes.popUpContent;
    
    return(
        <Dialog open={props.open} PaperProps={{ style: { width: `${props.dialogWidth}` , maxWidth : `${props.dialogWidth}`, maxHeight: props.isFeedBack ? 'calc(100vh - 30px)' : 'calc(100vh - 64px)'}}}>
            {!props.isFeedBack && (
            <DialogTitle style={{boxShadow: '0px 4px 40px 0px #00000014'}}>
                <Grid container alignItems='center' 
                    style={{ 
                        justifyContent: props.isFeedBack ? 'flex-end' : 'space-between' 
                    }}  
                >
                    <Typography style={{fontWeight:'bold'}}>{props.title.toUpperCase()}</Typography>
                    <IconButton onClick={props.onClose} size='small'>
                        <Close />
                    </IconButton>
                </Grid>
            </DialogTitle>
            )}
            <DialogContent className={dialogContentClasses}>
                {props.isFeedBack && (
                    <Grid container alignItems='center' style={{justifyContent:'end', marginBottom:'10px'}}>
                        <IconButton onClick={props.onClose} size='small'>
                            <Close />
                        </IconButton>
                    </Grid>
                )}
                {props.dialogContent}
                {props.buttonRequired && <Grid container>
                    <Grid item xs={12} md={12} style={{marginTop: "30px"}}>
                        <Grid container justifyContent='flex-end'>
                            <Grid item>
                                <Button variant='outlined' 
                                    style={{marginRight:"10px",width:'110px'}}
                                    onClick={props.onClose}
                                >{props.cancel}</Button>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' style={{backgroundColor:`${props.submitButtonColor}`,color:'#FFFFFF',width:'110px'}} onClick={props.onSubmit} disabled={props.disabled}
                                    >{props.submit}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>}
            </DialogContent>
        </Dialog>
    )
}